<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Επιβεβαίωση Παρουσιών</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <DxSelectBox :search-enabled="true" :data-source="months" search-mode="contains" search-expr="Description"
          :search-timeout="200" :min-search-length="2" :show-data-before-search="true" display-expr="Description"
          value-expr="Id" v-model="selectedMonthId" @value-changed="setSelectedMonth" placeholder="Επιλέξτε Μήνα"
          :show-clear-button="true" />
      </div>

      <div class="row">
        <div class="col-md-12 grid-pad">
          <!-- <DxDataGrid @initialized="saveGridInstance" 
                        :data-source="verifications"
                        :allow-column-reordering="true" 
                        :allow-column-resizing="true" 
                        :column-auto-width="true"
                        :show-borders="true" key-expr="Id" 
                        :show-row-lines="true" 
                        :row-alternation-enabled="true"
                        @row-updating="onRowUpdating" width="100%"> -->
          <DxDataGrid :data-source="verifications" :allow-column-reordering="true" :allow-column-resizing="true"
            :column-auto-width="true" :show-borders="true" key-expr="Id" :show-row-lines="true"
            :row-alternation-enabled="true" @row-updating="onRowUpdating" width="100%">
            <DxPaging :page-size="20" :enabled="true" />
            <DxEditing :allow-updating="true" mode="row" :use-icons="true" />
            <DxHeaderFilter :visible="true" />
            <DxFilterRow :visible="true" />
            <DxSearchPanel :visible="true" />

            <DxColumn caption="Νόμιμος Εκπρόσωπος" :allow-editing="false" data-field="ParentFullName" data-type="string"
              :visible="true" width="250px" alignment="left">
            </DxColumn>

            <DxColumn caption="Ωφελούμενη/ος" :allow-editing="false" data-field="KidFullName" :visible="true"
              width="200px" alignment="left" :allow-filtering="true">
            </DxColumn>

            <DxColumn caption="Κινητό Νόμιμου Εκπροσώπου" :allow-editing="false" data-field="ParentCelPhone"
              data-type="string" :visible="true" width="250px" alignment="left">
            </DxColumn>

            <DxColumn caption="Επιβεβαιωμένη" :allow-editing="false" data-field="IsVerified" data-type="string"
              :visible="true" width="50px" alignment="left" cell-template="diff-cell-template">
            </DxColumn>

            <DxColumn caption="OTP" :allow-editing="true" data-field="OneTimePassword" data-type="string"
              :visible="true" width="250px" alignment="left">
            </DxColumn>

            <DxColumn type="buttons">
              <DxButton name="edit" :visible="isUserOrganizationsIconVisible" />
              <DxButton name="btnSendVerificationSms" hint="Αποστολή SMS επαλήθευσης παρουσίας"
                :visible="isSendSmsVisible" icon="glyphicon glyphicon-envelope" :on-click="onSendVerificationSms" />
            </DxColumn>

            <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
            <template #masterDetailTemplate="{ data: masterrow }">
              <DetailTemplate :template-data="masterrow" />
            </template>

            <template #diff-cell-template="{ data }">
              <YesNoDxCell :cell-data="data.data.IsVerified" />
            </template>
          </DxDataGrid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "../../components/shared/backButton";
import { DxSelectBox } from "devextreme-vue/select-box";
import YesNoDxCell from "../../components/shared/yesNoDxCell";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import router from "../../router";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import notify from "devextreme/ui/notify";
import DetailTemplate from "./verficationDetails";

export default {
  components: {
    BackButton,
    DxSelectBox,
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxLoadIndicator,
    DxButton,
    DxMasterDetail,
    DetailTemplate,
    YesNoDxCell,
  },
  data() {
    return {
      months: [],
      selectedMonthId: 0,
      verifications: [],
      loadIndicatorVisible: false,
      showSmsIcon: false,
    };
  },
  created() {},
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    isUserOrganizationsIconVisible(e) {
      return e.row.data.IsVerified == false;
    },

    checkUserPermissions(){
      
      if(!this.isSuperAdmin  && !this.isAdmin && !this.isRepresentative  && !this.isUser){
        this.$router.push('/home');
      }
    },

    isSendSmsVisible(e) {
      //return false;
      //TODO: Uncomment if we want button for sending sms
      return e.row.data.IsVerified == false && this.showSmsIcon;
    },

    async setSelectedMonth(e) {
      this.loadIndicatorVisible = true;
      this.verifications = [];
      const res = await mainService.get(
        `/Verifications/GetVerificationRecordsForMainIndex?organizationId=${this.organizationId}&month=${this.selectedMonthId}`
      );
      this.verifications = res.data;
      this.loadIndicatorVisible = false;
    },

    async onRowUpdating(e) {
      
      var verification = Object.assign(e.oldData, e.newData);
      verification.Id = e.key;

      try {
        const res = await mainService.post(
          "/Verifications/VerifyVerification",
          verification
        );
        if (res.status != 200) {
          e.cancel = true;
        } else {
          notify("Οι παρουσίες επιβεβαιώθηκαν", "success", 1000);
        }
      } catch (error) {
        notify(
          "Η επιβεβαίωση απέτυχε! Ελέγξτε ότι ο Προσωρινός Κωδικός (OTP) είναι σωστός και ότι δεν έχει λήξει",
          "error",
          5000
        );
        e.cancel = true;
      }

      this.setSelectedMonth();
    },

    async getVerifigations() {
      const res1 = await mainService.get(
        `/Periods/GetAvailableMonthsInActivePeriod`
      );
      this.months = res1.data;

      var check = this.$moment();
      this.selectedMonthId = parseInt(check.format("M"));

      const globalParams = await mainService.get(
        `/GlobalParams/GetGlobalParams`
      );
      
      this.showSmsIcon = globalParams.data.ShowSmsIcon;
    },

    async onSendVerificationSms(verification) {
      
      try {
        const res = await mainService.post("/verifications/SendVerificationSms", verification.row.data);

        if (res.status == 1)
          notify("Η αποστολή SMS πέτυχε", "success", 2000);
        else
          notify("Η αποστολή SMS απέτυχε", "error", 2000);
      } catch (error) {
        notify("Η αποστολή SMS απέτυχε", "error", 2000);
      }
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      this.setSelectedMonth(null);
    },
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isRepresentative() {
      return this.$store.getters.isRepresentative;
    },
    isUser() {
      return this.$store.getters.isUser;
    },
  },
  async mounted() {
    this.checkUserPermissions();
    // const res1 = await mainService.get(
    //     `/Periods/GetAvailableMonthsInActivePeriod`
    // );
    // this.months = res1.data;

    // var check = this.$moment();
    // this.selectedMonthId = parseInt(check.format("M"));
    this.getVerifigations();
  },
};
</script>

<style scoped>
.cell-yes {
  color: green;
  font-weight: 700;
}
.cell-no {
  color: red;
  font-weight: 700;
}
</style>
